import { render, staticRenderFns } from "./CertificateImage.vue?vue&type=template&id=19b15780&scoped=true&"
import script from "./CertificateImage.vue?vue&type=script&lang=js&"
export * from "./CertificateImage.vue?vue&type=script&lang=js&"
import style0 from "./CertificateImage.vue?vue&type=style&index=0&id=19b15780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b15780",
  null
  
)

component.options.__file = "CertificateImage.vue"
export default component.exports